import React from 'react'

export const P = ({children, className}: {children: React.ReactNode, className?: string}) => {
    return (
        <p className={`text-black ${className ?? ''} text-base`}>
            {children}
        </p>
    )
}